module.exports = __webpack_public_path__ + "img/oddnary-variation-3.53d805e7.jpg";